import {
  ARPageShell
} from "./chunk-FXF7X2MJ.mjs";
import {
  characterSpec,
  prefetchCharacter
} from "./chunk-C7FE5SD3.mjs";

// src/components/Pages/CreaturePhoto/CreaturePhoto.tsx
import React, { useEffect } from "react";
import { CameraIcon } from "@heroicons/react/20/solid";
var loadCreaturePhotoView = () => import("./CreaturePhotoView-DV5THRFA.mjs");
var CreaturePhotoView = React.lazy(loadCreaturePhotoView);
var warmUpCreaturePhotoView = () => {
  void loadCreaturePhotoView().catch(() => void 0);
};
var DEFAULT_PHOTO_CREATURE = "fox";
function CreaturePhoto({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const creature = page.creature ?? DEFAULT_PHOTO_CREATURE;
  const spec = characterSpec(creature);
  const name = page.creatureName?.trim() || spec.label.toLowerCase();
  useEffect(() => {
    prefetchCharacter(creature);
  }, [creature]);
  return /* @__PURE__ */ React.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Creature Photo",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpCreaturePhotoView,
      copy: {
        startLabel: "Start looking",
        startIcon: CameraIcon,
        permissionPurpose: `to find ${name} and take the photo`,
        motionPurpose: `so ${name} can find a spot`,
        permissionDescription: `We use your camera (and motion on iOS) to place ${name} in the world around you and to take the photo.`,
        skipText: "Are you sure you want to skip the photo?",
        loadingLabel: `Waking ${name}\u2026`,
        emoji: spec.emoji,
        logTag: "CreaturePhoto",
        completeTitleFallback: "What a photo!",
        lookAgainLabel: "Take another",
        noCameraLabel: "Look without the camera"
      },
      renderView: ({ onFound, onComplete, sceneKey, noCamera }) => /* @__PURE__ */ React.createElement(
        CreaturePhotoView,
        {
          key: sceneKey,
          page,
          editorMode,
          noCamera,
          onFound,
          onComplete
        }
      )
    }
  );
}

export {
  DEFAULT_PHOTO_CREATURE,
  CreaturePhoto
};
//# sourceMappingURL=chunk-VALZG35Q.mjs.map